<!--项目报名-->
<template>
  <div>
    <div>
      <top-item-com active="10" :ssid="ssid"></top-item-com>
    </div>

    <!-- 中间赛事信息 开始 -->
    <div class="titleDiv">
      <p
        style="margin-top: 10px;margin-bottom: 5px;font-size: 17px;font-weight: 600;"
      >
        {{ ssInfo.SSMC }}
      </p>
      <p style="margin-top: 5px;margin-bottom: 5px;">
        <van-tag
          :type="
            ssInfo.BSZT === '1'
              ? 'primary'
              : ssInfo.BSZT === '3'
              ? 'danger'
              : ssInfo.BSZT === '6'
              ? 'warning'
              : ssInfo.BSZT === '7'
              ? 'success'
              : ''
          "
        >
          {{
            ssInfo.BSZT === "-1"
              ? "报名未开始"
              : ssInfo.BSZT === "1"
              ? "报名中"
              : ssInfo.BSZT === "3"
              ? "报名结束"
              : ssInfo.BSZT === "6"
              ? "比赛中"
              : ssInfo.BSZT === "7"
              ? "比赛结束"
              : ""
          }}
        </van-tag>
      </p>
      <p
        style="margin-top: 15px;margin-bottom: 5px;font-size: 15px;"
        v-if="ssInfo.BSQSRQ !== undefined && ssInfo.BSQSRQ.length > 0"
      >
        <van-icon name="underway-o" />
        <span style="color:#B2B2B2">比赛日期：</span>
        &nbsp;&nbsp;&nbsp;
        <span>{{ ssInfo.BSQSRQ }} 至 {{ ssInfo.BSJZRQ }}</span>
      </p>
      <p style="margin-top: 15px;margin-bottom: 5px;font-size: 15px;">
        <van-icon name="location-o" />
        <span style="color:#B2B2B2">比赛地址：</span>
        &nbsp;&nbsp;&nbsp;
        <span>{{ ssInfo.CGMC }}</span>
      </p>
    </div>
    <!-- 中间赛事信息 结束 -->

    <div class="titleDiv">
      <p style="margin-top: 10px;margin-bottom: 5px;font-size: 15px;">
        赛事指南：
      </p>
      <div v-html="SSZN"></div>
    </div>

    <div style="height:150px;width:15px;"></div>
    <loading-com></loading-com>
  </div>
</template>

<script>
import ChangeXm from "../commonCom/ChangeXm.vue";
import LoadingCom from "../commonCom/LoadingCom.vue";
import TopItemCom from "../commonCom/TopItemCom.vue";
export default {
  components: { ChangeXm, LoadingCom, TopItemCom },
  name: "SsznIndex",

  data() {
    return {
      BMNR: "",
      SSZN: "",
      grReportShow: false,
      utilPost: "",
      ssid: "",
      op: "wapGL",
      pageSet: {
        currentPage: 1, //当前页页码
        pageSize: 10, //每页默认显示的条数
        totalNums: 0 //数据总条数
      },
      search: {
        info: "",
        qslx: "",
        bszt: "",
        ssid: ""
      },
      ssInfo: {},
      resultXmList: [],
      sslxList: [],
      resultXmAllList: [],
      routeValue: ""
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
    this.search.ssid = this.ssid;
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {});
    }
    this.mainData();
  },
  methods: {
    mainData() {
      this.search.ssid = this.ssid;
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getSsxx" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.ssInfo = data.content[0];
        this.SSZN = data.content[0].SSZN;
      });
    },
    onTopClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.titleDiv {
  margin-top: 15px;
  margin-bottom: 15px;
  text-align: left;
  padding-left: 15px;
  background: #fff;
  padding-top: 5px;
  padding-bottom: 5px;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 5px;
}
.van-tag {
  font-size: 13px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 3px;
  padding-bottom: 3px;
}
.van-button {
  width: 130px;
  height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/SsznIndex/SsznIndex.vue